import { Menu, MenuItem, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useRecoilValue } from "recoil";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LoadingButton } from "@mui/lab";
import { authState } from "src/store/auth";
import { canManageRole } from "../../../add-edit-employee/constants";
import RowDetailsDrawer from "../row-details";

const TableActions = ({ row }: { row: any }) => {
  const navigate = useNavigate();
  const [openDetails, setOpenDetails] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const auth = useRecoilValue(authState);
  const { permissions, user } = auth;
  const roleType = user?.roleType;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigateToEditPage = () => {
    handleClose();
    navigate(`/employees/active/${row.employeeId}/edit`);
  };

  const handleOpenDetailsDrawer = () => {
    handleClose();
    setOpenDetails(true);
  };

  const handleCloseDetailsDrawer = () => {
    setOpenDetails(false);
  };

  const canManage = canManageRole(roleType, row.role);

  return (
    <Stack direction={"row"}>
      <LoadingButton
        id="basic-button"
        variant="contained"
        color="tertiary"
        endIcon={<KeyboardArrowDownIcon />}
        onClick={handleClick}
        size="small"
        sx={{ fontSize: "12px", color: "#7E8299", fontWeight: 600 }}
      >
        Actions
      </LoadingButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {canManage && permissions?.arsannEmployees.edit && (
          <MenuItem
            onClick={handleNavigateToEditPage}
            sx={{
              fontSize: "14px",
              p: "4px 15px",
            }}
          >
            View Profile
          </MenuItem>
        )}
        <MenuItem
          onClick={handleOpenDetailsDrawer}
          sx={{
            fontSize: "14px",
            p: "4px 15px",
          }}
        >
          Details
        </MenuItem>
      </Menu>

      {openDetails ? (
        <RowDetailsDrawer
          shiftDetails={row}
          open={openDetails}
          onClose={handleCloseDetailsDrawer}
        />
      ) : null}
    </Stack>
  );
};
export default TableActions;
